import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import Select from 'components/v2/Select'
import EmployeeStatusLabel from './labels/EmployeeStatusLabel'

export default function EmployeeSelect(props) {
  const { excludeInactive, showStatus, ...selectProps } = props

  const fetch = async (where) => {
    let finalWhere = where

    if (excludeInactive) {
      finalWhere = {
        and: [
          where,
          { estatus: { eq: "ACTIVE" } }
        ]
      }
    }

    const { employees } = await fetchQuery(
      graphql`
        query EmployeeSelectQuery($where: EmployeeWhere) {
          employees(where: $where, first: 10, orderBy: [primerNombre], order: ASC) {
            edges {
              node {
                id
                fullName
                fullNameSearch
                estatus
              }
            }
          }
        }
      `,
      { where: finalWhere }
    )

    return employees.edges.map(({ node }) => ({
      key: node.id,
      value: node.id,
      text: node.fullName,
      ...(showStatus && {
        content: (
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}>
            <span>{node.fullName}</span>
            <EmployeeStatusLabel status={node.estatus} />
          </div>
        )
      })
    }))
  }

  return (
    <Select
      {...selectProps}
      getByValue={(value) => fetch({ id: { eq: value } })}
      loadOptions={(searchQuery) => fetch({ fullNameSearch: { iLike: `%${searchQuery}%` } })}
    />
  )
}

EmployeeSelect.defaultProps = {
  label: 'Empleado',
  placeholder: 'Empleado',
  loadOnMount: false,
  excludeInactive: true,
  showStatus: true,
}